/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Program.Performance.vue?vue&type=template&id=99e5c4be"
import script from "./Program.Performance.vue?vue&type=script&lang=js"
export * from "./Program.Performance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports